// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.animation[data-v-064cbb50] {\n  transition: transform 0.3s ease-in-out;\n}\n.list-view[data-v-064cbb50] {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n.list-top[data-v-064cbb50] {\n overflow: hidden;\n text-align: center;\n}\n.list-contain[data-v-064cbb50] {\n  height: 100%;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
